export const default_server = process.env.REACT_APP_DEFAULT_SERVER;
export const default_client = process.env.REACT_APP_DEFAULT_CLIENT;
export const default_safari_bundle = process.env.REACT_APP_DEFAULT_SAFARI_BUNDLE;
